import { FC, useMemo } from "react";

import {
  BulkEditFormContext,
  IBulkEditFormContext,
  usePageContext,
  useSelectedIds,
} from "@ryde/redux";
import { RydeUiUnit } from "@ryde/shared";

import { BulkUpdateFormDrawerContent } from "./bulk-update-form.drawer.content";

interface IBulkUpdateFormDrawer {
  forceEntity?: RydeUiUnit;
}

export const BulkUpdateFormDrawer: FC<IBulkUpdateFormDrawer> = ({
  forceEntity,
} = {}) => {
  const { entity: entityFromContext } = usePageContext();
  const entity = forceEntity ?? entityFromContext;
  const { selectedRowsValues } = useSelectedIds(entity);

  const bulkEditFormContext = useMemo<IBulkEditFormContext>(
    () => ({ entity, isBulkEditForm: true, selectedRowsValues }),
    [entity, selectedRowsValues],
  );

  return (
    <BulkEditFormContext.Provider value={bulkEditFormContext}>
      <BulkUpdateFormDrawerContent entity={entity} />
    </BulkEditFormContext.Provider>
  );
};
